import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import LeadForm from './LeadForm';

const { FiArrowRight, FiCheckCircle, FiPhoneCall } = FiIcons;

export function PageHero({ eyebrow, title, text, children }) {
  return (
    <section className="page-hero">
      <div className="page-hero-inner">
        <Reveal>
          <span className="eyebrow light">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{text}</p>
          <div className="hero-actions">
            <a className="button button-white" href="https://meet.cambiadigital.com/consult" target="_blank" rel="noopener noreferrer">Get Your Free Tech Reality Check™</a>
            <a className="text-link light-link" href="tel:+17185550142"><SafeIcon icon={FiPhoneCall} /> Talk to an advisor</a>
          </div>
        </Reveal>
        {children && <Reveal className="page-hero-card">{children}</Reveal>}
      </div>
    </section>
  );
}

export function SectionHeading({ eyebrow, title, text, center = false }) {
  return (
    <div className={`section-heading ${center ? 'center' : ''}`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}

export function CheckList({ items }) {
  return (
    <ul className="check-list">
      {items.map((item) => <li key={item}><SafeIcon icon={FiCheckCircle} />{item}</li>)}
    </ul>
  );
}

export function FinalCTA({ title = 'Get a clear answer before you sign another contract.' }) {
  return (
    <section className="final-cta">
      <div className="final-cta-grid">
        <div>
          <span className="eyebrow light">Free, no-obligation assessment</span>
          <h2>{title}</h2>
          <p>We’ll review what you have, identify gaps and wasted spend, and map the right next step.</p>
          <Link className="text-link light-link" to="/contact">Prefer a conversation? Contact us <SafeIcon icon={FiArrowRight} /></Link>
        </div>
        <LeadForm compact />
      </div>
    </section>
  );
}